import { memo } from 'react';

import { type PublicBoardItemsViewProps } from '~/components/v2/components/board/PublicBoardContent';
import { PublicBoardTableView } from '~/components/v2/components/board/shared/table/PublicBoardTableView';
import { usePublicTableViewItems } from '~/swr-hooks/gallery/tableView/usePublicTableViewItems';

export type PublicBoardPageTableViewProps = PublicBoardItemsViewProps;

/**
 * The standalone board link's table view — this surface's fetch scope over the shared table body,
 * composed into PublicBoard's TableView slot by PublicBoardPage.
 */
export const PublicBoardPageTableView = memo(({ scrollElementRef }: PublicBoardPageTableViewProps) => {
  // No collectionId: a standalone board link has no collection — the fetch's one designed absence
  // (collection surfaces always state their scope explicitly).
  const itemsData = usePublicTableViewItems();

  return <PublicBoardTableView itemsData={itemsData} scrollElementRef={scrollElementRef} />;
});

PublicBoardPageTableView.displayName = 'PublicBoardPageTableView';
